<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-16 md:py-12 py-8">
    <div
      class="lg:w-1/2 md:w-2/3 w-full mx-auto text-center lg:mb-16 md:mb-10 mb-6"
    >
      <h2 class="font-semibold fsize40 md-fsize28 sm-fsize20 clr-black">
        Categories
      </h2>
    </div>

    <div
      class="w-full grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-10 md:gap-10 gap-6"
    >
      <div
        class="rounded-xl p-8 bg-f4f5f6"
        v-for="(item, index) in getAllCategory.result"
        :key="index"
      >
        <div class="w-full rounded-xl">
          <img
            class="lg:h-56 h-48 w-full object-contain rounded-xl"
            :src="`${$imageURL}/${item.image}`"
            alt="img"
          />
        </div>

        <div class="pt-4">
          <p class="font-bold fsize16">
            {{ item.name }}
          </p>
          <p class="fsize16 ellipsis-5" v-html="item.description"></p>
          <div
            class="flex items-center mt-2 cursor-pointer"
            @click="handleRedirect(item._id)"
          >
            <p class="font-semibold text-primary">
              {{ item.podcast_count }} Seasons
            </p>
            <feather-icon
              icon="ArrowRightIcon"
              class="text-primary"
              svgClasses="w-5 h-5 ml-1"
            ></feather-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  methods: {
    async dataLoad() {
      await this.$store.dispatch("podcast/getall_category");
    },
    handleRedirect(id) {
      this.$router.push({
        name: "podcast-seasonpage",
        query: {
          cid: id,
        },
      });
    },
  },
  computed: {
    ...mapState("podcast", { getAllCategory: "getAllCategory" }),
  },
  mounted() {
    this.dataLoad();
  },
};
</script>
